import { useNeueVersion } from "@/hooks/useNeueVersion";

/**
 * Dezenter Hinweis, wenn eine neue Fassung veröffentlicht wurde.
 *
 * Bewusst ein Angebot, kein erzwungener Neustart: Wer gerade eine Buchung ausfüllt,
 * entscheidet selbst, wann sie neu lädt. Sitzt unten links, damit weder der
 * Cookie-Banner (z-[9999], unten) noch die Sticky-CTAs der Landingpages (z-50, unten
 * mittig/rechts) verdeckt werden.
 */
export function NeueVersionHinweis() {
  const { neueVersion, jetztLaden } = useNeueVersion();

  if (!neueVersion) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] rounded-xl bg-[#644B40] px-4 py-3 text-white shadow-lg sm:max-w-sm"
      style={{ bottom: "max(1rem, var(--safe-bottom,0px))" }}
    >
      <p className="text-small">Es gibt eine neue Version der Seite.</p>
      <button
        type="button"
        onClick={jetztLaden}
        className="mt-2 min-h-[44px] w-full rounded-lg bg-white px-4 text-label text-[#644B40] hover:bg-[#F3EFE8]"
      >
        Jetzt neu laden
      </button>
    </div>
  );
}
